export default "__VITE_ASSET__CPvZYBih__"